import { render, staticRenderFns } from "./UploadedFilesModal.vue?vue&type=template&id=59d87eda&scoped=true&"
import script from "./UploadedFilesModal.vue?vue&type=script&lang=js&"
export * from "./UploadedFilesModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFilesModal.vue?vue&type=style&index=0&id=59d87eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d87eda",
  null
  
)

export default component.exports